import ModalWindow from './modalWindow';

export default ModalWindow;